<div class="post-body">
  <div class="header">
    <div class="headline">{{ heading() }}</div>
    <rt-icon-button
      variant="transparent-light"
      iconName="close"
      iconColor="colorIconOnboardingLowDefault"
      size="small"
      (click)="closeTooltip()"
    />
  </div>
  <div class="description">{{ description() }}</div>
  @if (helpArticleKey) {
    <a [rtHelpArticle]="helpArticleKey" rt-button variant="outline-ghost" class="learn-more">
      <span>{{ 'app.walkthrough.post.learn_more' | translate }}</span>
      <rt-icon name="open-in-new" />
    </a>
  }
</div>

<div class="post-footer">
  <rt-divider variant="tint line" margin-tb />
  <div class="footer-container">
    <div class="step-counter">
      {{ currentStep() }} {{ 'app.common.of' | translate }} {{ stepsTotal() }}
    </div>
    <div class="actions-container">
      <rt-button class="main-action" variant="tertiary" (click)="finish.emit()">
        @if (ctaIcon) {
          <rt-icon [name]="ctaIcon" prefix />
        }
        <span>{{ ctaText() }}</span>
      </rt-button>
    </div>
  </div>
</div>
